// Campus photo for /colleges/james-madison-university: CC BY-SA 4.0, by Atb17, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AJMU_Quad_Fall_2015.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/james-madison-university/; credited under the photo.
const photo = {
    "slug": "james-madison-university",
    "alt": "Wilson Hall and the Quad in autumn at James Madison University in Harrisonburg, Virginia",
    "src": "/colleges/james-madison-university/campus-1600.webp",
    "srcSmall": "/colleges/james-madison-university/campus-800.webp",
    "srcMid": "/colleges/james-madison-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/james-madison-university/og.jpg",
    "title": "JMU Quad Fall 2015",
    "author": "Atb17",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AJMU_Quad_Fall_2015.JPG",
    "read": "2026-10-01"
};

export default photo;
